export { StorytellingCardUp as default } from './StorytellingCardUp';
